export default __webpack_public_path__ + "static/media/incog-dlp-banner.ec97d999.svg";